import { render, staticRenderFns } from "./abnormalRecords.vue?vue&type=template&id=53656278&"
import script from "./abnormalRecords.vue?vue&type=script&lang=js&"
export * from "./abnormalRecords.vue?vue&type=script&lang=js&"
import style0 from "./abnormalRecords.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports